export const environment = {
    apiUrl: require('./config.json').apiUrl
}